document.addEventListener('DOMContentLoaded',()=>{
  const b=document.querySelector('[data-j-burger]');
  const m=document.querySelector('[data-j-mobile]');
  if(b&&m){
    const close=()=>{m.classList.remove('open');b.setAttribute('aria-expanded','false');};
    b.setAttribute('aria-expanded','false');
    b.addEventListener('click',()=>{
      const open=!m.classList.contains('open');
      m.classList.toggle('open',open);
      b.setAttribute('aria-expanded',open?'true':'false');
    });
    m.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));
    m.querySelectorAll('[data-j-subtoggle]').forEach(toggle=>{
      toggle.addEventListener('click',()=>{
        const group=toggle.closest('[data-j-mobile-group]');
        if(!group)return;
        const willOpen=!group.classList.contains('is-open');
        m.querySelectorAll('[data-j-mobile-group]').forEach(g=>{
          g.classList.remove('is-open');
          const t=g.querySelector('[data-j-subtoggle]');
          if(t)t.setAttribute('aria-expanded','false');
        });
        if(willOpen){
          group.classList.add('is-open');
          toggle.setAttribute('aria-expanded','true');
        }
      });
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
  }

  document.querySelectorAll('[data-j-product]').forEach(root=>{
    const raw=root.querySelector('[data-j-variants]');
    if(!raw)return;

    let variants=[];
    try{variants=JSON.parse(raw.textContent)}catch(e){return}

    const variantSelect=root.querySelector('[data-j-variant-select]');
    const idInput=root.querySelector('input[name="id"]');
    const price=root.querySelector('[data-j-price]');
    const submit=root.querySelector('button[type="submit"]');
    const mainImage=root.querySelector('[data-j-main-image]');
    const thumbs=[...root.querySelectorAll('[data-j-thumb]')];
    const form=root.querySelector('form[action*="/cart/add"]');

    const findVariant=id=>variants.find(v=>String(v.id)===String(id));

    const setMainImage=variant=>{
      if(!variant || !mainImage || !variant.image)return;
      mainImage.src=variant.image;
      mainImage.alt=variant.title || '';
      thumbs.forEach(thumb=>{
        const same=String(thumb.dataset.jThumbMediaId)===String(variant.imageId);
        thumb.classList.toggle('is-active',same);
      });
    };

    const applyVariant=(variant,replaceUrl=true)=>{
      if(!variant)return;

      if(variantSelect)variantSelect.value=String(variant.id);
      if(idInput)idInput.value=String(variant.id);

      if(price){
        price.textContent=new Intl.NumberFormat('fr-FR',{
          style:'currency',
          currency:'EUR'
        }).format(Number(variant.price)/100);
      }

      if(submit){
        submit.disabled=!variant.available;
        submit.textContent=variant.available?'Ajouter au panier':'Indisponible';
      }

      setMainImage(variant);

      if(replaceUrl){
        const u=new URL(window.location.href);
        u.searchParams.set('variant',variant.id);
        history.replaceState({},'',u);
      }
    };

    const urlVariantId=new URL(window.location.href).searchParams.get('variant');
    const initial=(urlVariantId && findVariant(urlVariantId))
      || (variantSelect && findVariant(variantSelect.value))
      || variants[0];

    applyVariant(initial,false);

    if(variantSelect){
      variantSelect.addEventListener('change',()=>applyVariant(findVariant(variantSelect.value),true));
    }

    thumbs.forEach(thumb=>{
      thumb.addEventListener('click',()=>{
        const variant=variants.find(v=>String(v.imageId)===String(thumb.dataset.jThumbMediaId));
        if(variant){
          applyVariant(variant,true);
        }else if(mainImage && thumb.dataset.jThumbSrc){
          mainImage.src=thumb.dataset.jThumbSrc;
          thumbs.forEach(t=>t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        }
      });
    });

    if(form){
      form.addEventListener('submit',()=>{
        const variant=variantSelect ? findVariant(variantSelect.value) : initial;
        if(variant){
          if(idInput)idInput.value=String(variant.id);
          if(variantSelect)variantSelect.value=String(variant.id);
        }
      });
    }
  });
});
